import React from 'react';
import styles from './Modal.module.scss';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
  disableBackdropClick?: boolean;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, className, disableBackdropClick }) => {
  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (!disableBackdropClick) {
      onClose();
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.modalContent + (className ? ' ' + className : '')} onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
};

export default Modal; 